import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type StatsCardColor = 'blue' | 'green' | 'purple' | 'orange';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: IconDefinition;
  color?: StatsCardColor;
  clickable?: boolean;
  onClick?: () => void;
}

export default function StatsCard({
  title,
  value,
  icon,
  color = 'blue',
  clickable = false,
  onClick
}: StatsCardProps): React.ReactElement {
  const colorClasses: Record<StatsCardColor, string> = {
    blue: 'bg-blue-100 text-blue-600 border-blue-200',
    green: 'bg-green-100 text-green-600 border-green-200',
    purple: 'bg-purple-100 text-purple-600 border-purple-200',
    orange: 'bg-orange-100 text-orange-600 border-orange-200'
  };

  const cardClasses = `bg-white rounded-lg border shadow-sm p-6 ${
    clickable
      ? 'cursor-pointer hover:shadow-md hover:border-gray-300 transition-all duration-200'
      : ''
  }`;

  const content = (
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className="text-3xl font-bold text-gray-900">{value}</p>
      </div>
      <div className={`p-3 rounded-full ${colorClasses[color] || colorClasses.blue}`}>
        <FontAwesomeIcon icon={icon} className="w-6 h-6" />
      </div>
    </div>
  );

  return (
    <div className={cardClasses} onClick={clickable ? onClick : undefined}>
      {content}
    </div>
  );
}
